import axios from "axios";
import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts";
import { BACKEND_BASEURL } from "../../db/baseUrl";
import { toast } from "react-toastify";

const darkColors = [
  "#0B3D91", // Dark Azure
  "#2C3E50", // Dark Blue-Gray
  "#800020", // Burgundy
  "#3A3D4D", // Deep Charcoal
  "#4B0082", // Dark Indigo
  "#581845", // Dark Purple
  "#6A0572", // Dark Amethyst
  "#8B0000", // Dark Red
  "#1A202C", // Dark Slate Gray
  "#964B00", // Dark Brown
  "#3B5323", // Olive Drab
  "#013220", // Deep Forest Green
  "#004953", // Deep Teal
  "#000080", // Navy Blue
  "#2F4F4F", // Dark Slate
  "#483D8B", // Dark Slate Blue
  "#556B2F", // Dark Olive Green
  "#5F9EA0", // Cadet Blue
  "#2E0854", // Dark Violet
  "#0D1117", // Jet Black
];
const generateRandomColor = () => {
  const randomIndex = Math.floor(Math.random() * darkColors.length);
  return darkColors[randomIndex];
};

const CashierSale = () => {
  const [lastWeekSale, setLastWeekSale] = useState([]);
  const [lastMonthSale, setLastMonthSale] = useState([]);
  const [todaySale, setTodaySale] = useState([]);
  const getTotalSaleLastWeek = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getLastWeekSaleByUsername`
      );
      const fetchedData = response.data;
      setLastWeekSale(fetchedData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      // toast.error(message);
    }
  };
  const getTotalSaleToday = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getTodaySaleByUsername`
      );
      const fetchedData = response.data;
      setTodaySale(fetchedData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      // toast.error(message);
    }
  };
  const getTotalSaleLastMonth = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getLastMonthSaleByUsername`
      );
      const fetchedData = response.data;
      console.log(fetchedData);
      setLastMonthSale(fetchedData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      // toast.error(message);
    }
  };

  useEffect(() => {
    getTotalSaleLastWeek();
    getTotalSaleLastMonth();
    getTotalSaleToday();
  }, []);

  const [salesData, setSalesData] = useState(todaySale);

  const colors = salesData.map((i) => generateRandomColor());
  console.log(colors);

  const [selectedValue, setSelectedValue] = useState("today");

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    if (selectedValue === "today") {
      setSalesData(todaySale);
    }
    if (selectedValue === "lastWeek") {
      setSalesData(lastWeekSale);
    }
    if (selectedValue === "lastMonth") {
      setSalesData(lastMonthSale);
    }
  }, [todaySale, selectedValue, lastWeekSale, lastMonthSale]);

  return (
    <div className=" w-[100%]  h-60 overflow-y-auto scrollbar-hide">
      <div className="flex justify-between items-center gap-2 sticky top-0 ">
        <h2 className="text-lg font-semibold">Sale by Cashier</h2>
        <select
          className="outline-none p-1"
          value={selectedValue}
          onChange={handleChange}
        >
          <option value="today">Today</option>
          <option value="lastWeek">lastWeek</option>
          <option value="LastMonth">LastMonth</option>
        </select>
      </div>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={salesData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({
              cx,
              cy,
              midAngle,
              innerRadius,
              outerRadius,
              percent,
              index,
            }) => {
              if (percent === 0) return null;

              const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
              const x = cx + radius * Math.cos((-midAngle * Math.PI) / 180);
              const y = cy + radius * Math.sin((-midAngle * Math.PI) / 180);

              return (
                <text
                  x={x}
                  y={y}
                  fill="white"
                  textAnchor={x > cx ? "start" : "end"}
                  dominantBaseline="central"
                  fontSize="10px"
                >
                  {`${(percent * 100).toFixed(0)}% `}
                </text>
              );
            }}
            outerRadius="78%"
            dataKey="totalSale"
          >
            {salesData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index]} />
            ))}
          </Pie>
          <Legend
            layout="vertical"
            align="right"
            verticalAlign="middle"
            wrapperStyle={{
              fontSize: "0.6rem",
            }}
            formatter={(value, entry, index) => {
              const cashier = salesData[index];
              return `${cashier.name} - Rs:${cashier.totalSale}`;
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CashierSale;
